const modules = {};
const requireModule = require.context('.', false, /\.service\.js$/);

requireModule.keys().forEach((fileName) => {
  const moduleName = fileName
    .replace(/\.service\.js$/i, 'Service')
    .replace(/(\.\/|\.js)/g, '')
    .replace(/\./g, '');

  modules[moduleName] = requireModule(fileName).default || requireModule(fileName);
});

export default modules;
